<div class="p-4" *ngIf="!atividade">
</div>

<div *ngIf="atividade">
  <form #form="ngForm" [formGroup]="atividadeAddForm" class="flex flex-col gap-6">
    <!-- Identificação -->
    <p-fieldset toggleable="true">
      <ng-template pTemplate="header">
        <span class="font-semibold">Identificação</span>
      </ng-template>
      <div class="grid grid-cols-1 md:grid-cols-2 p-4">

        <div class="flex flex-col gap-3 ml-[60px]">
          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Número da OS:</label>
            <div id="numeroBa" class="ml-3">{{ atividade.numeroBA }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Origem Atendimento:</label>
            <div class="ml-3">{{ atividade.origemAtendimento }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Equipe - Responsável:</label>
            <div id="equipeResponsavel" class="ml-3">
              {{
                atividade.equipeResponsavel && atividade.responsavel
                  ? atividade.equipeResponsavel + ' - ' + atividade.responsavel
                  : atividade.equipeResponsavel || atividade.responsavel
              }}
            </div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Empresa:</label>
            <div class="ml-3">{{ atividade.siglaSpe }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">OS de Origem:</label>
            <div class="ml-3">{{ atividade.numeroBAOriginal }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Código OS de Origem:</label>
            <div class="ml-3">{{ atividade.codTipoOsOrigem }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Desc. OS de Origem:</label>
            <div class="ml-3">{{ atividade.descOsOrigem }}</div>
          </div>
        </div>

        <div class="flex flex-col gap-3">
          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Status:</label>
            <div id="atividadeStatus" class="ml-3">{{ atividade.status + ' (' + atividade.statusAtividade + ')' }}</div>
          </div>

          <div class="flex gap-2" *ngIf="atividade.statusMotivo">
            <label class="font-semibold min-w-fit">Motivo Bloqueio:</label>
            <div class="ml-3">{{ atividade.statusMotivo }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Visitas Realizadas:</label>
            <div class="ml-3">{{ atividade.visitasRealizadas }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Tempo de Execução (minutos):</label>
            <div class="ml-3">{{ atividade.tempoExecucao }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Unidade Operacional:</label>
            <div class="ml-3">{{ atividade.unidadeOperacional }}</div>
          </div>
        </div>
      </div>
    </p-fieldset>

    <p-fieldset toggleable="true">
      <ng-template pTemplate="header">
        <span class="font-semibold">Serviço</span>
      </ng-template>
      <div class="grid grid-cols-1 md:grid-cols-2 p-4">
        <div class="flex flex-col gap-3 ml-[60px]">
          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Código:</label>
            <div>{{ atividade.siglaAtvTipo }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Descrição:</label>
            <div>{{ atividade.descTipoAtividade }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Característica da Equipe:</label>
            <div>{{ atividade.caracteristicaEquipe }}</div>
          </div>
        </div>

        <div class="flex flex-col gap-3">
          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Tipo de Atendimento:</label>
            <div>
              {{
                atividade.tipoAtendimento === 'I'
                  ? 'IMEDIATO'
                  : atividade.tipoAtendimento === 'P'
                  ? 'PROGRAMADO'
                  : 'Outro'
              }}
            </div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Classificação:</label>
            <div>{{ atividade.classificacao }}</div>
          </div>
        </div>
      </div>
    </p-fieldset>

    <p-fieldset toggleable="true">
      <ng-template pTemplate="header">
        <span class="font-semibold">Localização</span>
      </ng-template>
      <div class="grid grid-cols-1 md:grid-cols-2 p-4">
        <div class="flex flex-col gap-3 ml-[60px]">
          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Unidade:</label>
            <div>{{ atividade.unidadeOrg }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Cliente:</label>
            <div>{{ atividade.cliente }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Endereço:</label>
            <div id="endereco">{{ atividade.endereco }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Referência:</label>
            <div>{{ atividade.referencia }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Latitude:</label>
            <div>{{ atividade.latitude }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Longitude Original:</label>
            <div>{{ atividade.longitudeOriginal }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Setor-Rota-Face-Seq:</label>
            <div>{{ atividade.setorRotaFaceSeq }}</div>
          </div>
        </div>

        <div class="flex flex-col gap-3">
          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Matrícula:</label>
            <div>{{ atividade.matricula_Imovel }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Contato:</label>
            <div>{{ atividade.contato }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Telefone Solicitante:</label>
            <div>{{ atividade.tel_Solicitante }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Identificador do Cliente:</label>
            <div>{{ atividade.identificadorCliente }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Longitude:</label>
            <div>{{ atividade.longitude }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Longitude Original:</label>
            <div>{{ atividade.longitudeOriginal }}</div>
          </div>
        </div>
      </div>
    </p-fieldset>

    <p-fieldset toggleable="true">
      <ng-template pTemplate="header">
        <span class="font-semibold">Acompanhamento</span>
      </ng-template>
      <div class="grid grid-cols-1 md:grid-cols-2 p-4">
        <div class="flex flex-col gap-3 ml-[60px]">
          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Geração da OS:</label>
            <div class="ml-3">{{ atividade.geracaoOS | date : 'dd/MM/yyyy HH:mm' }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Data Recebimento SIGOS:</label>
            <div class="ml-3">{{ atividade.dataRecebimentoMaxline | date : 'dd/MM/yyyy HH:mm' }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Data Processamento SIGOS:</label>
            <div class="ml-3">{{ atividade.dataImportacaoMaxline | date : 'dd/MM/yyyy HH:mm' }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Limite de Atendimento:</label>
            <div class="ml-3">{{ atividade.limiteAtendimento | date : 'dd/MM/yyyy HH:mm' }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Recebido pela Equipe:</label>
            <div class="ml-3">{{ atividade.recebidoTecnico | date : 'dd/MM/yyyy HH:mm' }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Data Reprogramação:</label>
            <div class="ml-3">{{ atividade.dataReprogramacao | date : 'dd/MM/yyyy HH:mm' }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Data Liberação Pendência:</label>
            <div class="ml-3">{{ atividade.dataLiberacaoPendencia | date : 'dd/MM/yyyy HH:mm' }}</div>
          </div>
        </div>

        <div class="flex flex-col gap-3">
          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Data Início Agendamento:</label>
            <div class="ml-3">{{ atividade.dataInicioAgendamento | date : 'dd/MM/yyyy HH:mm' }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Data Fim Agendamento:</label>
            <div class="ml-3">{{ atividade.dataFimAgendamento | date : 'dd/MM/yyyy HH:mm' }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Deslocamento Iniciado:</label>
            <div class="ml-3">{{ atividade.deslocamentoIniciado | date : 'dd/MM/yyyy HH:mm' }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Início Execução Programado:</label>
            <div class="ml-3">{{ atividade.inicioExecucaoProgramada | date : 'dd/MM/yyyy HH:mm' }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Início Execução Real:</label>
            <div class="ml-3">{{ atividade.inicioExecucaoReal | date : 'dd/MM/yyyy HH:mm' }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Fim Execução Programado:</label>
            <div class="ml-3">{{ atividade.fimExecucaoProgramada | date : 'dd/MM/yyyy HH:mm' }}</div>
          </div>

          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Fim Execução Real:</label>
            <div id="fimExecucaoReal" class="ml-3">{{ atividade.fimExecucaoReal | date : 'dd/MM/yyyy HH:mm' }}</div>
          </div>
        </div>
      </div>
    </p-fieldset>

    <p-fieldset toggleable="true">
      <ng-template pTemplate="header">
        <span class="font-semibold">Dados da Instalação</span>
      </ng-template>
      <div class="p-4">
        <div class="grid grid-cols-1 md:grid-cols-2 mb-4">
          <div class="flex flex-col gap-3 ml-[60px]">
            <div class="flex gap-2">
              <label class="font-semibold min-w-fit">TPS de Execução:</label>
              <div>{{ atividade.tpSdeExecucao }}</div>
            </div>

            <div class="flex gap-2">
              <label class="font-semibold min-w-fit">Número do Ponto de Serviço:</label>
              <div>{{ atividade.numeroDoPontoDeServico }}</div>
            </div>

            <div class="flex gap-2">
              <label class="font-semibold min-w-fit">Número do Hidrômetro:</label>
              <div>{{ atividade.numeroDoHidrometro }}</div>
            </div>

            <div class="flex gap-2">
              <label class="font-semibold min-w-fit">Localização do Padrão:</label>
              <div>{{ atividade.localizacaoDoPadrao }}</div>
            </div>

            <div class="flex gap-2">
              <label class="font-semibold min-w-fit">Data da Instalação:</label>
              <div>{{ atividade.dataInstalacao | date : 'dd/MM/yyyy' }}</div>
            </div>
          </div>

          <div class="flex flex-col gap-3">
            <div class="flex gap-2">
              <label class="font-semibold min-w-fit">Situação do Imóvel - Água:</label>
              <div>{{ atividade.situacaoDoImovelAgua }}</div>
            </div>

            <div class="flex gap-2">
              <label class="font-semibold min-w-fit">Situação do Imóvel - Esgoto:</label>
              <div>{{ atividade.situacaoDoImovelEsgoto }}</div>
            </div>

            <div class="flex gap-2">
              <label class="font-semibold min-w-fit">Situação do PS:</label>
              <div>{{ atividade.situacaoDoPS }}</div>
            </div>

            <div class="flex gap-2">
              <label class="font-semibold min-w-fit">Consumo Médio no PS:</label>
              <div>{{ atividade.consumoMedioNoPs }}</div>
            </div>

            <div class="flex gap-2">
              <label class="font-semibold min-w-fit">Ramo de Atividade Principal:</label>
              <div>{{ atividade.ramoDeAtividadePrincipal }}</div>
            </div>
          </div>
        </div>

        <!-- Tabelas -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-[60px]">
          <div>
            <p-table
              [value]="atividadeGrid?.economiaPorCategorias || []"
              [tableStyle]="{ 'font-size': '12px' }"
              styleClass="p-datatable-sm p-datatable-gridlines">
              <ng-template pTemplate="caption" class="bg-gray-100">
                <div class="flex items-center p-2 justify-between font-semibold">Economias por Categoria</div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr class="bg-gray-100">
                  <th class="text-gray-700">TPS</th>
                  <th class="text-gray-700">Comercial</th>
                  <th class="text-gray-700">Industrial</th>
                  <th class="text-gray-700">Pública</th>
                  <th class="text-gray-700">Residencial</th>
                  <th class="text-gray-700">Social</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td class="break-words text-sm">{{ item.tps }}</td>
                  <td class="break-words text-sm">{{ item.comercial }}</td>
                  <td class="break-words text-sm">{{ item.industrial }}</td>
                  <td class="break-words text-sm">{{ item.publica }}</td>
                  <td class="break-words text-sm">{{ item.residencial }}</td>
                  <td class="break-words text-sm">{{ item.social }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <div>
            <p-table
              [value]="atividadeGrid?.leiturasImovel || []"
              [tableStyle]="{ 'font-size': '12px' }"
              styleClass="p-datatable-sm p-datatable-gridlines">
              <ng-template pTemplate="caption" class="bg-gray-100">
                <div class="flex items-center p-2 justify-between font-semibold">Leituras do Imóvel</div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr class="bg-gray-100">
                  <th class="text-gray-700">Mês/Ano</th>
                  <th class="text-gray-700">Data Leitura</th>
                  <th class="text-gray-700">CF</th>
                  <th class="text-gray-700">Volume Faturado</th>
                  <th class="text-gray-700">Leitura</th>
                  <th class="text-gray-700">CA</th>
                  <th class="text-gray-700">Ocorrência</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td class="break-words text-sm">{{ item.mesAnoLeitura }}</td>
                  <td class="break-words text-sm">
                    {{ item.dataLeitura.startsWith('1900') ? '' : (item.dataLeitura | date : 'dd/MM/yyyy') }}
                  </td>
                  <td class="break-words text-sm">{{ item.cfLeitura }}</td>
                  <td class="break-words text-sm">{{ item.volumeFaturado }}</td>
                  <td class="break-words text-sm">{{ item.leituraFaturado }}</td>
                  <td class="break-words text-sm">{{ item.caLeitura }}</td>
                  <td class="break-words text-sm">{{ item.ocorrenciaLeitura }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
          <div>
            <p-table
              [value]="atividadeGrid?.resumoDePs || []"
              [tableStyle]="{ 'font-size': '12px' }"
              styleClass="p-datatable-sm p-datatable-gridlines">
              <ng-template pTemplate="caption" class="bg-gray-100">
                <div class="flex items-center p-2 justify-between font-semibold">Resumo de PS</div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr class="bg-gray-100">
                  <th class="text-gray-700">TPS</th>
                  <th class="text-gray-700">Situação PS</th>
                  <th class="text-gray-700">Quantidade</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td class="break-words text-sm">{{ item.tps }}</td>
                  <td class="break-words text-sm">{{ item.situacaoPS }}</td>
                  <td class="break-words text-sm">{{ item.quantidade }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <div>
            <p-table
              [value]="atividadeGrid?.debitosCliente || []"
              [tableStyle]="{ 'font-size': '12px' }"
              styleClass="p-datatable-sm p-datatable-gridlines">
              <ng-template pTemplate="caption" class="bg-gray-100">
                <div class="flex items-center p-2 justify-between font-semibold">Débitos</div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr>
                  <th>Mês/Ano Referência</th>
                  <th>Vencimento</th>
                  <th>Valor</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td class="break-words text-sm">{{ item.dataReferencia }}</td>
                  <td class="break-words text-sm">{{ item.dataVencimento | date : 'dd/MM/yyyy' }}</td>
                  <td class="break-words text-sm">{{ (item.valorFatura | number : '1.2-2') || '' }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <div class="w-full mt-4">
          <label class="font-semibold">Informações Adicionais:</label>
          <div class="mt-2">{{ atividade.infoAdicionais }}</div>
        </div>
      </div>
    </p-fieldset>

    <p-fieldset toggleable="true" *ngIf="atividade.idAtividade > 0">
      <ng-template pTemplate="header">
        <span class="font-semibold">Cenário</span>
      </ng-template>
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 p-4">
        <div>
          <label class="font-semibold block">Cenário Prioridade:</label>
          <div class="mt-1">{{ atividade.cenario_Prioridade }}</div>
        </div>

        <div>
          <label class="font-semibold block">Cenário Tempo:</label>
          <div class="mt-1">{{ atividade.cenario_Tempo }}</div>
        </div>

        <div>
          <label class="font-semibold block">Cenário Tratamento:</label>
          <div class="mt-1">{{ atividade.cenario_Tratamento }}</div>
        </div>

        <div>
          <label class="font-semibold block">Cenário Classificação:</label>
          <div class="mt-1">{{ atividade.cenario_Classificacao }}</div>
        </div>

        <div>
          <label class="font-semibold block">Seleção OS:</label>
          <div class="mt-1">{{ atividade.cenario_SelecaoOS }}</div>
        </div>

        <div>
          <label class="font-semibold block">Ranqueamento:</label>
          <div class="mt-1">{{ atividade.ranqueamento }}</div>
        </div>
      </div>
    </p-fieldset>

    <p-fieldset [toggleable]="true" [(collapsed)]="imagesFieldsetCollapsed">
        <ng-template pTemplate="header">
            <span class="font-semibold">Imagens</span>
        </ng-template>
        <div class="p-4" *ngIf="atividade?.idAtividade && showImages">
            <mf-atividade-image #containerImagens
            (imagensChange)="verificarImagens($event)"
            [idAtividade]="atividade.idAtividade"
            [showImages]="showImages"
            (downloadConcluido)="downloadConcluido()"
            [checkDownload]="checkDownload"
          >
            </mf-atividade-image>
        </div>
        <div class="p-4 pt-0" *ngIf="toiMidias?.length">
          <p class="font-semibold text-surface-800 dark:text-surface-200 mb-3 m-0">TOI</p>
          <div class="flex flex-wrap gap-4 md:gap-5">
            <div
              *ngFor="let m of toiMidias; let i = index"
              class="flex flex-col items-start gap-2 w-44 sm:w-48 shrink-0"
              [class.opacity-50]="isToiMidiaOculta(m, i)"
            >
              <div
                class="toi-midia-thumb w-full rounded-lg border border-surface-200 dark:border-surface-700 flex items-center justify-center overflow-hidden aspect-[4/3] min-h-24 bg-surface-100 dark:bg-surface-800 relative"
              >
                <img
                  *ngIf="m.urlThumbnail"
                  [src]="m.urlThumbnail"
                  [alt]="m.legenda"
                  class="w-full h-full max-w-full max-h-full object-contain object-center"
                  loading="lazy"
                />
                <i *ngIf="!m.urlThumbnail" class="pi pi-image text-4xl text-surface-400" aria-hidden="true"></i>
                <span
                  *ngIf="isToiMidiaOculta(m, i)"
                  class="absolute top-1 left-1 text-[10px] font-semibold bg-surface-900/80 text-surface-0 px-2 py-0.5 rounded"
                  >Oculto no PDF</span
                >
              </div>
              <a
                *ngIf="m.downloadUrl"
                [href]="m.downloadUrl"
                class="flex items-center gap-1.5 text-primary no-underline hover:underline"
                [attr.aria-label]="'Download TOI ' + m.legenda"
              >
                <i class="pi pi-download shrink-0" aria-hidden="true"></i>
                <span class="text-sm text-surface-700 dark:text-surface-300 leading-snug">TOI - {{ m.legenda }}</span>
              </a>
              <span *ngIf="!m.downloadUrl" class="text-sm text-surface-700 dark:text-surface-300 leading-snug"
                >TOI - {{ m.legenda }}</span
              >
            </div>
          </div>
        </div>
    </p-fieldset>

    <p-fieldset toggleable="true">
      <ng-template pTemplate="header">
        <span class="font-semibold">Eventos</span>
      </ng-template>
      <div class="p-4">
        <mf-atividade-events [idAtividade]="atividade.idAtividade"></mf-atividade-events>
      </div>
    </p-fieldset>

    <p-fieldset>
      <ng-template pTemplate="header">
        <span class="font-semibold">Funcionalidades</span>
      </ng-template>
      <div class="flex flex-wrap gap-3 p-4">
        <p-button
          label="Editar Coordenadas"
          icon="pi pi-map-marker"
          styleClass="p-button-help w-64"
          (onClick)="updCoordenadas()">
        </p-button>

        <p-button
          label="Eventos"
          icon="pi pi-flag"
          styleClass="p-button-warn w-64"
          (onClick)="openEventos()">
        </p-button>

        <p-button
          label="Exportar Dados da OS"
          icon="pi pi-file-pdf"
          styleClass="p-button-success w-64"
          (onClick)="transformPDF()">
        </p-button>


        <p-button *ngIf="imageContent"
        label="Exportar Imagens para PDF"
        icon="pi pi-file-pdf"
        styleClass="p-button-success w-64"
        (onClick)="gerarPdf()"
        [loading]="loading">
       </p-button>

        <p-button *ngIf="imageContent"
            styleClass="p-button-success w-64"
            label="Exportar Imagens para .ZIP"
            icon="pi pi-file-export"
            (click)="exportarZip()" />
      </div>
    </p-fieldset>
  </form>

  <p-toast></p-toast>

  <!-- Dialog Editar Coordenadas -->
  <p-dialog header="Editar Coordenadas" [(visible)]="visible" [style]="{ width: '40vw' }">
    <div class="flex flex-col gap-4">
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="font-semibold block mb-2">Latitude:</label>
          <div>{{ atividade?.latitude }}</div>
        </div>
        <div>
          <label class="font-semibold block mb-2">Longitude:</label>
          <div>{{ atividade?.longitude }}</div>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="font-semibold block mb-2">Latitude Ajustada:</label>
          <input
            #latitudeInput
            id="latitude"
            class="w-full"
            type="number"
            pInputText
            [(ngModel)]="latitudeAjustada"
            placeholder="-99,9999999999999"
          />
        </div>
        <div>
          <label class="font-semibold block mb-2">Longitude Ajustada:</label>
          <input
            #longitudeInput
            id="longitude"
            class="w-full"
            type="number"
            pInputText
            [(ngModel)]="longitudeAjustada"
            placeholder="-99,9999999999999"
          />
        </div>
      </div>
    </div>

    <div class="flex gap-2 mt-6">
      <p-button
        label="Cancelar"
        icon="pi pi-times"
        severity="primary"
        variant="outlined"
        [style]="{width: '120px'}"
        (onClick)="onClose()">
      </p-button>
      <p-button
        label="Confirmar"
        icon="pi pi-check"
        (onClick)="onConfirmCoordenadas(atividade.idAtividade)"
        [disabled]="!latitudeAjustada || !longitudeAjustada">
      </p-button>
    </div>
  </p-dialog>

  <!-- Dialog Eventos -->
  <p-dialog
    *ngIf="eventosVisible"
    header="Eventos"
    [(visible)]="eventosVisible"
    [style]="{ width: '90vw', height: '90vh' }">
    <div>
      <mf-atividade-events
        [idAtividade]="atividade.idAtividade"
        (loadLista)="loadEvents($event)">
      </mf-atividade-events>
    </div>
    <div *ngIf="events !== undefined" class="mt-4">
      <app-google-maps [events]="events"></app-google-maps>
    </div>
  </p-dialog>
</div>
